import { Fragment } from 'react';
import { Row } from 'reactstrap';
import RightHeader from '@layout/header/rightbar';
import styled from 'styled-components';

const Header = (props) => {
  return (
    <Fragment>
      <PageHeader className="page-header">
        <HeaderRow className="header-wrapper m-0">
          {/* <LeftHeader data={props.data} mid={props.mid} /> */}
          <RightHeader
            screenType={props.screenType}
            data={props.data}
            mid={props.mid}
            isShowSide={props.isShowSide}
            setIsShowSide={props.setIsShowSide}
          />
        </HeaderRow>
      </PageHeader>
    </Fragment>
  );
};

export default Header;

const PageHeader = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 15.5rem;
  width: calc(100% - 15.5rem) !important;
  max-width: none;
  height: 3.75rem;
  margin-left: 0 !important;
  z-index: 300;
  border-bottom: 1px solid ${({ theme }) => theme.neutralGray[200]};
  background: ${({ theme }) => theme.white};
  box-shadow: none;

  @media (max-width: 1279px) {
    left: 0;
    width: 100% !important;
    margin-left: 0 !important;
    height: 3.75rem;
  }

  @media (max-width: 767px) {
    height: 3.125rem;
  }
`;

const HeaderRow = styled(Row)`
  height: 100%;
  padding: 0 1.25rem;

  @media (max-width: 1279px) {
    padding: 0 1.25rem;
  }

  @media (max-width: 767px) {
    padding: 0 0.75rem;
  }
`;
